/* eslint-disable no-nested-ternary */

import {
  Drawer,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { useState, useEffect, useRef, useContext } from 'react';
// import { store } from 'contexts/Map/store';
import { FDContext } from 'contexts/Map/fdStore';
// import fetchData from 'helpers/fetchData';

import { setAPIFD, setOrderName, setToken } from 'contexts/Map/action';
import { getTokenUsageConsumptionList } from 'api/partialdr/subscriptions';
import { getUserUsages } from 'api/usages';
import { getTokenData } from 'api/fieldDelineation/subscriptions';

import PointDrawer from './PointDrawer';
import BBoxDrawer from './BBoxDrawer';
import FieldIdDrawer from './FieldIdDrawer';
import CoverageDrawer from './CoverageDrawer';
import DRCoverageDrawer from './DRCoverageDrawer';
import DRTileDrawer from './DRTileDrawer';
import DRBboxDrawer from './DRBboxDrawer';
import TimeSeriesFieldIdDrawer from './TimeSeriesFieldIdDrawer';
import TimeSeriesCoverage from './TimeSeriesCoverage';
import { TokenContext } from '../../contexts/Tokens/TokenContext';

// Import the useMapContext, usePopupContext, and clearAllMapPopups utility
import { useMapContext, usePopupContext, clearAllMapPopups } from './index';

const useStyles = makeStyles({
  drawer: {
    width: 560,
    '@media (max-width: 600px)': {
      width: 'unset',
      maxHeight: 300,
      overflowY: 'scroll',
    },
  },
  root: {
    width: 560,
    '@media (max-width: 600px)': {
      width: 'unset',
      maxHeight: 300,
    },
    backgroundColor: '#fff',
    fontSize: 14,
    '& h3': {
      fontSize: 20,
      lineHeight: 1.2,
      margin: 0,
    },
  },
  info: {
    padding: '24px 20px',
    boxSizing: 'border-box',
    color: '#949EA7',
    backgroundColor: '#fff',
    marginBottom: 8,
    '& h3': {
      lineHeight: '24px',
      marginBottom: 8,
      color: '#1D2023',
    },
    '& h4': {
      color: '#1D2023',
      fontSize: 18,
      lineHeight: '24px',
      fontWeight: 600,
      margin: 0,
    },
    '& h6': {
      color: '#1D2023',
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 700,
      margin: 0,
    },
  },

  flex: {
    display: 'flex',
  },
  flex1: {
    flex: 1,
  },
  inputRoot: {
    borderRadius: 4,
  },
});

const RightDrawer = (props) => {
  const classes = useStyles();
  const { open, onClose } = props;

  const {
    state: { mode, drawMode: mapDrawMode, dataLayerFD, orderName },
    dispatch,
  } = useContext(FDContext);

  // Add map and popup context
  const { map } = useMapContext();
  const { mapTopPopupRef, setMapTopPopupRef } = usePopupContext();

  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const { tokens, setTokens } = useContext(TokenContext);
  const [date, setDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [tokensLoaded, setTokensLoaded] = useState(false);
  const [localSelectedToken, setLocalSelectedToken] = useState('');

  const defaultLiveToken = tokens.find((t) => t.label === 'live')?.value || '';

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const tokensDetail = await getTokenData();
      const tokensFromDetail = Array.isArray(tokensDetail)
        ? tokensDetail
            .map((detail) =>
              detail && detail.token
                ? {
                    label: detail.type ? detail.type : 'Digifarm (N/A)',
                    value: detail.token,
                  }
                : null
            )
            .filter(Boolean)
        : [];

      const newTokens = [
        { label: 'All Tokens', value: 'all' },
        ...tokensFromDetail,
      ];
      setTokens(newTokens);
      setTokensLoaded(true);
    } catch (error) {
      console.error('Failed to fetch token and credits: ', error);
      setTokensLoaded(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Set default token only after tokens are loaded and if no token is already set
  useEffect(() => {
    if (
      tokensLoaded &&
      tokens.length > 0 &&
      !dataLayerFD.token &&
      !localSelectedToken
    ) {
      const liveToken = tokens.find((t) => t.label === 'live')?.value;
      const firstAvailableToken = tokens.find(
        (t) => t.label !== 'All Tokens'
      )?.value;

      const tokenToSet = liveToken || firstAvailableToken;

      if (tokenToSet) {
        setLocalSelectedToken(tokenToSet);
        dispatch({
          type: setToken,
          payload: {
            token: tokenToSet,
          },
        });
      }
    }
  }, [tokensLoaded, tokens, dataLayerFD.token, localSelectedToken, dispatch]);

  // Sync local token with context token
  useEffect(() => {
    if (dataLayerFD.token && dataLayerFD.token !== localSelectedToken) {
      setLocalSelectedToken(dataLayerFD.token);
    }
  }, [dataLayerFD.token]);

  // Get the current selected token value - use local state as fallback
  const currentTokenValue = localSelectedToken || dataLayerFD.token || '';

  return (
    <Drawer
      anchor={windowSize < 600 ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      ModalProps={{ BackdropProps: { invisible: true } }}
      variant="persistent"
      className={open ? 'right-side-drawer open' : 'right-side-drawer'}
      PaperProps={{
        style: {
          top: '64px',
        },
      }}
    >
      <div className={classes.root}>
        <div
          style={{
            padding: '24px 20px 0px 20px',
            boxSizing: 'border-box',
            backgroundColor: '#fff',
            marginBottom: '0px',
          }}
        >
          <h3
            style={{
              marginTop: '0px',
              marginLeft: '0px',
              marginBottom: '16px',
              fontSize: '25px',
              backgroundColor: 'white',
              fontWeight: 'bolder',
              fontFamily: 'Inter, sans-serif',
              color: '#1D2023',
            }}
          >
            Create New Order
          </h3>
          <TextField
            label="Order Name"
            value={orderName || ''}
            onChange={(event) => {
              dispatch({
                type: setOrderName,
                payload: { orderName: event.target.value },
              });
            }}
            fullWidth
            style={{ marginTop: '10px', marginBottom: '20px' }}
          />

          <FormControl
            fullWidth
            variant="outlined"
            style={{ marginBottom: '20px' }}
          >
            <InputLabel id="token-select-label">Choose your token</InputLabel>
            <Select
              labelId="token-select-label"
              label="Choose your token"
              value={currentTokenValue}
              onChange={(e) => {
                const selectedToken = e.target.value;
                // console.log('Token selected:', selectedToken);
                // console.log(
                //   'Before dispatch - Current token:',
                //   dataLayerFD.token
                // );
                // console.log('setToken action type:', setToken);

                // Update local state immediately for responsive UI
                setLocalSelectedToken(selectedToken);

                // Dispatch the action
                const action = {
                  type: setToken,
                  payload: {
                    token: selectedToken,
                  },
                };
                // console.log('Dispatching action:', action);
                dispatch(action);
              }}
              inputProps={{ 'aria-label': 'Select Token' }}
              disabled={isLoading || tokens.length === 0}
            >
              {tokens.map((tokenOption) => (
                <MenuItem
                  key={`${tokenOption.label}-${tokenOption.value}`}
                  value={tokenOption.value}
                  disabled={tokenOption.label === 'All Tokens'}
                >
                  {tokenOption.label}: {tokenOption.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl
            fullWidth
            variant="outlined"
            style={{ marginBottom: '10px' }}
          >
            <InputLabel id="query-type-select-label">Query Type</InputLabel>
            <Select
              labelId="query-type-select-label"
              label="Query Type"
              id="right-drawer-mode-select"
              value={dataLayerFD.api}
              onChange={(event) => {
                // First clear all popups when changing query type
                clearAllMapPopups(map, mapTopPopupRef, setMapTopPopupRef);

                // Then dispatch the action to update the context
                dispatch({
                  type: setAPIFD,
                  payload: {
                    api: event.target.value,
                    drawMode:
                      // eslint-disable-next-line no-nested-ternary
                      event.target.value === 'lowResBBOX' ||
                      event.target.value === 'bbox'
                        ? 'draw_rectangle'
                        : event.target.value === 'point'
                        ? 'draw_point'
                        : '',
                  },
                });
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                // getContentAnchorEl: null,
              }}
            >
              {/* What to do when the api is lowResTile */}
              {dataLayerFD.type === 'delineatedFields' && (
                <MenuItem value="lowResBBOX">
                  Query low res. boundaries (by BBOX){' '}
                </MenuItem>
              )}
              {dataLayerFD.type === 'delineatedFields' && (
                <MenuItem value="lowResTile">
                  Query low res. boundaries (by Tile){' '}
                </MenuItem>
              )}
              {dataLayerFD.type === 'delineatedFields' && (
                <MenuItem value="point">Query by Point</MenuItem>
              )}
              {dataLayerFD.type === 'delineatedFields' && (
                <MenuItem value="bbox">Query by BBOX</MenuItem>
              )}
              {/* {dataLayerFD.type === "delineatedFields" && ()} */}

              {dataLayerFD.type === 'deepResImages' && (
                <MenuItem value="xyz">Query by Tile URL</MenuItem>
              )}
              {dataLayerFD.type === 'deepResImages' && (
                <MenuItem value="bbox">Query by BBOX</MenuItem>
              )}
              {dataLayerFD.type === 'timeSeries' && (
                <MenuItem value="lowResBBOX">
                  Query low res. boundaries (by BBOX){' '}
                </MenuItem>
              )}
              {dataLayerFD.type === 'timeSeries' && (
                <MenuItem value="lowResTile">
                  Query low res. boundaries (by Tile){' '}
                </MenuItem>
              )}
              <MenuItem value="coverage">Check Coverage area</MenuItem>
            </Select>
          </FormControl>
        </div>
        {dataLayerFD.type === 'delineatedFields' ? (
          <>
            {dataLayerFD.api === 'point' && <PointDrawer tokens={tokens} />}
            {dataLayerFD.api === 'bbox' && <BBoxDrawer tokens={tokens} />}
            {(dataLayerFD.api === 'lowResBBOX' ||
              dataLayerFD.api === 'lowResTile') && (
              <FieldIdDrawer tokens={tokens} />
            )}
            {dataLayerFD.api === 'coverage' && (
              <CoverageDrawer tokens={tokens} />
            )}
          </>
        ) : dataLayerFD.type === 'deepResImages' ? (
          <>
            {dataLayerFD.api === 'xyz' && <DRTileDrawer tokens={tokens} />}
            {dataLayerFD.api === 'bbox' && <DRBboxDrawer tokens={tokens} />}
            {dataLayerFD.api === 'coverage' && (
              <DRCoverageDrawer tokens={tokens} />
            )}
          </>
        ) : (
          <>
            {(dataLayerFD.api === 'lowResBBOX' ||
              dataLayerFD.api === 'lowResTile') && (
              <TimeSeriesFieldIdDrawer tokens={tokens} />
            )}
            {dataLayerFD.api === 'coverage' && (
              <TimeSeriesCoverage tokens={tokens} />
            )}
          </>
        )}
      </div>
    </Drawer>
  );
};

export default RightDrawer;
